import { DEFAULT_LOCALE } from 'shared/consts'
import store from 'shared/store'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

const containerEl = document.querySelector(
  '[data-clientside-hook="r-NowCountdownContainer"]'
)
const mount = async container => {
  const {
    publicConfig: { locale = DEFAULT_LOCALE },
  } = store.getPublicRuntimeConfig()
  const catalogs = await loadCatalogs(locale)

  const nowCoundownContainerContainer = await import(
    /* webpackChunkName: "NowCountdownContainerWithRender", webpackPrefetch: true */
    './NowCountdownContainerWithRender'
  )

  nowCoundownContainerContainer.default({
    container,
    catalogs,
  })
}

export default () => {
  if (containerEl) {
    mount(containerEl)
  }
}
